export const types = {
  ADD_TO_GENDER_FILTER: 'ADD_TO_GENDER_FILTER',
  REMOVE_FROM_GENDER_FILTER: 'REMOVE_FROM_GENDER_FILTER',
  ADD_TO_COMPETENCY_FILTER: 'ADD_TO_COMPETENCY_FILTER',
  REMOVE_FROM_COMPETENCY_FILTER: 'REMOVE_FROM_COMPETENCY_FILTER',
  ADD_TO_CULTURALEXPERTISE_FILTER: 'ADD_TO_CULTURALEXPERTISE_FILTER',
  REMOVE_FROM_CULTURALEXPERTISE_FILTER: 'REMOVE_FROM_CULTURALEXPERTISE_FILTER',
  ADD_TO_EXPERTISE_FILTER: 'ADD_TO_EXPERTISE_FILTER',
  REMOVE_FROM_EXPERTISE_FILTER: 'REMOVE_FROM_EXPERTISE_FILTER',
  ADD_TO_LANGUAGE_FILTER: 'ADD_TO_LANGUAGE_FILTER',
  REMOVE_FROM_LANGUAGE_FILTER: 'REMOVE_FROM_LANGUAGE_FILTER',
  CLEAR_ALL_FILTERS: 'CLEAR_ALL_FILTERS',
  QUERY_STRING_PARAMS_TO_API: 'QUERY_STRING_PARAMS_TO_API',
	CHANGE_REGION: 'CHANGE_REGION',
	CHANGE_AVAILABLE_SUBREGIONS: 'CHANGE_AVAILABLE_SUBREGIONS',
  INIT_LOCATION_DATA: 'INIT_LOCATION_DATA',
  INIT_GENDER_DATA: 'INIT_GENDER_DATA',
  INIT_LANGUAGE_DATA: 'INIT_LANGUAGE_DATA',
  INIT_THERAPIST_EXPERIENCE_DATA: 'INIT_THERAPIST_EXPERIENCE_DATA',
  INIT_CULTURAL_EXPERIENCE_DATA:'INIT_CULTURAL_EXPERIENCE_DATA',
	ADD_SUBREGIONS: 'ADD_SUBREGIONS',
  DELETE_SUBREGIONS: 'DELETE_SUBREGIONS',
  UPDATE_SHOW_OPTIONS: 'UPDATE_SHOW_OPTIONS',
  UPDATE_SHOW_RESULTS_COUNT_TEXT: 'UPDATE_SHOW_RESULTS_COUNT_TEXT',
  UPDATE_SHOW_NO_RESULTS_TEXT: 'UPDATE_SHOW_NO_RESULTS_TEXT',
  FILTER_SEARCH_RESULT: 'FILTER_SEARCH_RESULT',
  API_ERROR: 'API_ERROR',
  BUILD_PAGINATION_ARRAY: 'BUILD_PAGINATION_ARRAY',
  URL_QUERY_STRING_PARAMS_TO_API: 'URL_QUERY_STRING_PARAMS_TO_API'
}

export default {
  [types.ADD_TO_GENDER_FILTER](state, payload) {
    if (!(state.selectedGender.find(item => item == payload.ID))) {
      state.selectedGender.push(payload.ID);
    }
  },
  [types.REMOVE_FROM_GENDER_FILTER](state, payload) {
    state.selectedGender = state.selectedGender.filter(item => item !== payload.ID);
  },
  [types.ADD_TO_COMPETENCY_FILTER](state, payload) {
    if (!(state.selectedCompetency.find(item => item == payload.ID))) {
      state.selectedCompetency.push(payload.ID);
    }
  },
  [types.REMOVE_FROM_COMPETENCY_FILTER](state, payload) {
    state.selectedCompetency = state.selectedCompetency.filter(item => item !== payload.ID);
  },
  [types.ADD_TO_CULTURALEXPERTISE_FILTER](state, payload) {
    if (!(state.selectedCulturalExpertise.find(item => item == payload.ID))) {
      state.selectedCulturalExpertise.push(payload.ID);
    }
  },
  [types.REMOVE_FROM_CULTURALEXPERTISE_FILTER](state, payload) {
    state.selectedCulturalExpertise = state.selectedCulturalExpertise.filter(item => item !== payload.ID);
  },
  [types.ADD_TO_EXPERTISE_FILTER](state, payload) {
    if (!(state.selectedExpertise.find(item => item == payload.ID))) {
      state.selectedExpertise.push(payload.ID);
    }
  },
  [types.REMOVE_FROM_EXPERTISE_FILTER](state, payload) {
    state.selectedExpertise = state.selectedExpertise.filter(item => item !== payload.ID);
  },
  [types.ADD_TO_LANGUAGE_FILTER](state, payload) {
    if (!(state.selectedLanguage.find(item => item == payload.ID))) {
      state.selectedLanguage.push(payload.ID);
    }
  },
  [types.REMOVE_FROM_LANGUAGE_FILTER](state, payload) {
    state.selectedLanguage = state.selectedLanguage.filter(item => item !== payload.ID);
  },
  [types.CLEAR_ALL_FILTERS](state) {
    state.selectedGender = [];
    state.selectedExpertise = [];
    state.selectedCulturalExpertise = [];
    state.selectedLanguage = [];
    state.selectedCompetency = [];
    state.selectedRegion = [];
    state.subRegionsForRegion = [];
    state.selectedSubRegions = [];
  },
  [types.QUERY_STRING_PARAMS_TO_API](state) {
    state.queryStringArrayToAPI = [];
    state.queryStringObjectToAPI = {};
    state.queryStringToAPI = "";
    if (state.selectedGender.length > 0) {
      state.queryStringArrayToAPI.push(['Gender', state.selectedGender.map(item => item.substring(2)).join(',')]);
    }
    if (state.selectedExpertise.length > 0 || state.selectedCulturalExpertise.length > 0) {
      state.queryStringArrayToAPI.push(['Expertise', state.selectedExpertise.map(item => item.substring(2)).concat(state.selectedCulturalExpertise.map(item => item.substring(2))).join(',')]);
    }
    if (state.selectedLanguage.length > 0) {
      state.queryStringArrayToAPI.push(['Language', state.selectedLanguage.map(item => item.substring(2)).join(',')]);
    }   
    if (state.selectedCompetency.length > 0) {
      state.queryStringArrayToAPI.push(['Competency', state.selectedCompetency.map(item => item.substring(2)).join(',')]);
    } 
    if (state.selectedRegion.length > 0) {
      state.queryStringArrayToAPI.push(['ContractRegion', state.selectedRegion.join(',')]);
    }
    if (state.selectedSubRegions.length > 0) {
      state.queryStringArrayToAPI.push(['ContractSubRegion', state.selectedSubRegions.map(item => item.ID).join(',')]);
    }
    for (var i in state.queryStringArrayToAPI) {
      state.queryStringObjectToAPI[state.queryStringArrayToAPI[i][0]] = state.queryStringArrayToAPI[i][1];
    }
    state.queryStringToAPI = Object.keys(state.queryStringObjectToAPI).map(key => key + '=' + state.queryStringObjectToAPI[key]).join('&');
  },
  [types.URL_QUERY_STRING_PARAMS_TO_API](state, payload){
    const qsObj = Object.fromEntries(new URLSearchParams(payload));
    Object.keys(qsObj).forEach(function (key) {
      if (key == 'Page') {
        state.paginationCurrentPage = qsObj[key];
      } else if (key == 'ContractRegion') {
        state.selectedRegion.push(qsObj[key]);
        state.disableSubRegionDropdown = false;
      } else if (key == 'ContractSubRegion') {
        let qsContractSubRegionArr = qsObj[key].split(',');
        qsContractSubRegionArr.forEach((item) => {
          if (typeof state.locationData[state.selectedRegion-1].SubRegions.find(SubRegion => SubRegion.ID == item) != 'undefined') {
            let subRegionObj = {};
            subRegionObj["ID"] = item;
            let subRegionName = state.locationData[state.selectedRegion-1].SubRegions.find(SubRegion => SubRegion.ID == item)['Name'];
            subRegionObj["Name"] = subRegionName;
            state.selectedSubRegions.push(subRegionObj);
          }
        });
      } else if (key == 'Gender') {
        let qsGenderArr = qsObj[key].split(',');
        qsGenderArr.forEach((item) => {
          state.selectedGender.push(`GE${item}`);
        });        
      } else if (key == 'Language') {
        let qsLanguageArr = qsObj[key].split(',');
        qsLanguageArr.forEach((item) => {
          state.selectedLanguage.push(`LA${item}`);
        });        
      } else if (key == 'Competency') {
        let qsCompetencyArr = qsObj[key].split(',');
        qsCompetencyArr.forEach((item) => {
          state.selectedCompetency.push(`CO${item}`);
        });        
      } else if (key == 'Expertise') {
        let qsExpertiseArr = qsObj[key].split(',');
        qsExpertiseArr.forEach((item) => {
          if (Number.parseInt(item) <= 7) {
            state.selectedExpertise.push(`EX${item}`);
          } else {
            state.selectedCulturalExpertise.push(`CU${item}`);    
          }
        }); 
      }       
    });
    state.messageType = '';
    state.message = '';
  },
	[types.INIT_LOCATION_DATA](state, payload){
		state.locationData = payload.locationJSON.slice();
  },
  [types.INIT_GENDER_DATA](state, payload){
		state.genderData = payload.genderJSON.slice();
  },
  [types.INIT_LANGUAGE_DATA](state, payload){
		state.languageData = payload.languageJSON.slice();
  },
  [types.INIT_THERAPIST_EXPERIENCE_DATA](state, payload){
		state.therapistExperienceData = payload.therapistExperienceJSON.slice();
  },
  [types.INIT_CULTURAL_EXPERIENCE_DATA](state, payload){
		state.culturalExperienceData = payload.culturalExperienceJSON.slice();
  },
	[types.CHANGE_REGION] (state, payload) {
		state.selectedRegion = [];
    state.selectedSubRegions = []; 
    state.disableSubRegionDropdown = false;
		if (payload.regionID > 0) {
			state.selectedRegion.push(payload.regionID);
		}
	},
	[types.CHANGE_AVAILABLE_SUBREGIONS] (state, payload) {
		state.subRegionsForRegion = [];
		if (state.locationData.find(item => item.ID == payload.regionID)) {
			const subRegionsArray = state.locationData.filter(item => item.ID == payload.regionID).map(item => item.SubRegions);
			subRegionsArray[0].forEach((item) => {
				let subRegionObj = {};
				subRegionObj["ID"] = item.ID;
				subRegionObj["Name"] = item.Name;
				state.subRegionsForRegion.push(subRegionObj);
			});
    }
  },
  [types.ADD_SUBREGIONS](state, payload) {
    if (!(state.selectedSubRegions.find(item => item.ID == payload.ID))) {
      state.selectedSubRegions.push(payload);
    }
  },
  [types.DELETE_SUBREGIONS](state, payload) {
    state.selectedSubRegions = state.selectedSubRegions.filter(item => item.ID !== payload.ID);
  },
  [types.UPDATE_SHOW_OPTIONS](state, payload) {
    state.optionalExpanded = payload;
  },
  [types.UPDATE_SHOW_RESULTS_COUNT_TEXT](state, payload) {
    state.showResultsCountText = payload;
  },
  [types.UPDATE_SHOW_NO_RESULTS_TEXT](state, payload) {
    state.showNoResultsText = payload;
  },
  [types.FILTER_SEARCH_RESULT](state, payload) {
    state.loading = false;
    state.messageType = 'success';
    state.message = '';
    state.filterSearchResponse = payload;
  },
  [types.API_ERROR](state, payload) {
    state.loading = false;
    state.messageType = 'error';
    state.message = payload.error;
  },
  [types.BUILD_PAGINATION_ARRAY](state, payload) {
    state.pagination = [];
    state.paginationCurrentPage = payload.page;

    //Previous arrow display logic
    if (payload.page > 1) {
      state.paginationShowPrevious = true;
    } else {
      state.paginationShowPrevious = false;
    }
    
    //Next arrow display logic
    if (payload.pageCount < 2) {
      state.paginationShowNext = false;
    } else {
      state.paginationShowNext = true;
    }

    //minNum logic
    let minNum = 1;

    if (payload.pageCount >= 7 ) {
      if (payload.page - 3 > 0) {
        minNum = payload.page - 3;
      }
    }

    //maxNum logic
    let maxNum = 0;
    
    if (payload.pageCount > 7) {
      if (payload.page > 3) {
        if (payload.page + 3 < payload.pageCount) {
          maxNum = payload.page + 3;
        } else {
          maxNum = payload.pageCount
        }
      } else {
        maxNum = 7;
      }
    } else {
      maxNum = payload.pageCount;
    }
    
    //Create arry based on minNum and MaxNum
    for (let i = minNum; i < maxNum + 1; i++) {
      state.pagination.push(i);
    }
  }
}